var React = require('react');

function AlertBannerDecorationInline (props) {
    return React.createElement("svg",props,[React.createElement("mask",{"id":"mask0_2835_40783","style":{"maskType":"alpha"},"maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"943","height":"864","key":0},React.createElement("rect",{"width":"943","height":"864","fill":"#D9D9D9"})),React.createElement("g",{"mask":"url(#mask0_2835_40783)","key":1},[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M639.219 0.432617L-2437.29 6221.16H-2401.07L675.442 0.432617H639.219Z","fill":"#FC3D24","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M573.51 0.432617L-2503 6221.16H-2466.78L609.733 0.432617H573.51Z","fill":"#FC3D24","key":1})])]);
}

AlertBannerDecorationInline.defaultProps = {"width":"943","height":"864","viewBox":"0 0 943 864","fill":"none"};

module.exports = AlertBannerDecorationInline;

AlertBannerDecorationInline.default = AlertBannerDecorationInline;
